import { gql, useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { ParticipantMatchField } from 'generated/event.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';

const submitParticipantSignatureMutationCall = gql`
  mutation SubmitParticipantSignature($input: SubmitParticipantSignatureInput!) {
    submitParticipantSignature(input: $input)
  }
`;

export const useSubmitParticipantSignatureMutation = () => {
  const [mutate, mutationState] = useMutation(submitParticipantSignatureMutationCall);

  const submitSignature = async (eventId: string, participantId: string, image: string, matchField?: ParticipantMatchField) => {
    try {
      await mutate({ variables: { input: { eventId, participantId, signatureImage: image, matchField } } });
      return true;
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        toast.error(String(customContext.message) || 'Failed to save signature');
      }
      return false;
    }
  };

  return [submitSignature, mutationState] as const;
};
